import React, { useState, useEffect } from 'react';
import styles from './CookieConsent.module.scss';

// Временный режим для демонстрации дизайна: показывать плашку всегда.
// Чтобы вернуть обычную логику, установите false.
const FORCE_SHOW_COOKIE_BANNER = false;

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (FORCE_SHOW_COOKIE_BANNER) {
      setIsVisible(true);
      return;
    }

    // Проверяем, есть ли куки с согласием
    const checkCookieConsent = () => {
      const consentCookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith('cookie_consent='));

      // Если куки нет, показываем баннер
      if (!consentCookie) {
        setIsVisible(true);
      }
    };

    checkCookieConsent();
  }, []);

  const handleAccept = () => {
    // Устанавливаем куки на 7 дней
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 7);
    document.cookie = `cookie_consent=accepted; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;

    // Скрываем баннер
    setIsVisible(false);
  };

  const handleDecline = () => {
    // Устанавливаем куки об отказе на 7 дней
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 7);
    document.cookie = `cookie_consent=declined; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;

    // Скрываем баннер
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.cookieConsent}>
      <div className={styles.cookieConsentContent}>
        <div className={styles.cookieConsentText}>
          <p>
            Мы используем файлы cookie для улучшения работы сайта и персонализации контента.
            Продолжая использовать сайт, вы соглашаетесь с использованием cookie.
          </p>
        </div>
        <div className={styles.cookieConsentButtons}>
          <button
            className={styles.acceptButton}
            onClick={handleAccept}
            type="button"
            aria-label="Принять использование cookie">
            Принять
          </button>
          <button
            className={styles.declineButton}
            onClick={handleDecline}
            type="button"
            aria-label="Отклонить использование cookie">
            Отклонить
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
